import React, { useState, useContext } from "react";
import { trackSuiteEvent } from "shared/util/track";
import { DemoLeadCaptureContext } from "./DemoLeadCaptureContext";
import BookDemoModal from "./BookDemoModal";

/**
 * Demo sırasında sol altta sabit duran "Book a setup call" butonu.
 *
 * Sadece DemoLeadCaptureProvider içinde (yani isDemo=true demo hesaplarında) render
 * edilir → servistesin ve gerçek ödeyen kullanıcılar bunu ASLA görmez.
 *
 * Tıklayınca önce e-posta+şirket yakalayan modal açılır (Calendly'ye doğrudan atmaz);
 * lead /lead-emails'e kaydedilir, sonra opsiyonel Calendly sunulur.
 */
const DemoBookCallButton = () => {
  const { requestedDemo, markDemoRequested } = useContext(DemoLeadCaptureContext);
  const [collapsed, setCollapsed] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);

  const label = requestedDemo ? "Demo requested ✓" : "Book a demo";

  const handleClick = () => {
    trackSuiteEvent("Demo — Book a Demo (persistent)", "button_click", { requested: requestedDemo });
    setModalOpen(true);
  };

  const navy = "var(--color-primary-surface, #1d3469)";

  if (collapsed) {
    return (
      <>
        <button
          type="button"
        onClick={handleClick}
        aria-label="Book a demo"
        title="Book a demo"
          style={{
            position: "fixed",
            left: "20px",
            bottom: "20px",
            zIndex: 99990,
            width: "52px",
            height: "52px",
            borderRadius: "50%",
            border: "none",
            background: navy,
            color: "#fff",
            cursor: "pointer",
            boxShadow: "0 8px 24px rgba(0,0,0,0.22)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: "22px",
          }}
        >
          📅
        </button>
        <BookDemoModal
          show={modalOpen}
          onClose={() => setModalOpen(false)}
          trigger="Demo — Persistent Button"
          onSuccess={markDemoRequested}
        />
      </>
    );
  }

  return (
    <>
    <div
      style={{
        position: "fixed",
        left: "20px",
        bottom: "20px",
        zIndex: 99990,
        display: "flex",
        alignItems: "center",
        gap: "8px",
        background: navy,
        color: "#fff",
        borderRadius: "999px",
        padding: "10px 14px 10px 16px",
        boxShadow: "0 8px 24px rgba(0,0,0,0.22)",
      }}
    >
      <button
        type="button"
        onClick={handleClick}
        style={{
          display: "flex",
          alignItems: "center",
          gap: "10px",
          background: "transparent",
          border: "none",
          color: "#fff",
          cursor: "pointer",
          fontSize: "14px",
          fontWeight: 600,
          padding: 0,
        }}
      >
        <span
          aria-hidden="true"
          style={{
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            width: "26px",
            height: "26px",
            borderRadius: "50%",
            background: "#fbe122",
            color: "#1d3469",
            fontSize: "15px",
          }}
        >
          {requestedDemo ? "✓" : "📅"}
        </span>
        {label}
      </button>
      <button
        type="button"
        onClick={() => setCollapsed(true)}
        aria-label="Minimize"
        title="Minimize"
        style={{
          background: "rgba(255,255,255,0.15)",
          border: "none",
          color: "#fff",
          cursor: "pointer",
          width: "22px",
          height: "22px",
          borderRadius: "50%",
          fontSize: "14px",
          lineHeight: 1,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        ×
      </button>
    </div>
      <BookDemoModal
        show={modalOpen}
        onClose={() => setModalOpen(false)}
        trigger="Demo — Persistent Button"
        onSuccess={markDemoRequested}
      />
    </>
  );
};

export default DemoBookCallButton;
